/**
 * Site-wide behaviour: announcement rotation, header hide/show, mobile menu, back to top.
 * Loaded as an ES module on every page.
 */
const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;

// Rotating announcement bar.
function initAnnouncement() {
  const box = document.querySelector('[data-ann]');
  if (!box || reduce) return;
  const msgs = [...box.children];
  if (msgs.length < 2) return;
  let i = 0;
  let timer = null;
  const step = () => {
    const cur = msgs[i];
    i = (i + 1) % msgs.length;
    const nxt = msgs[i];
    cur.classList.add('out');
    cur.classList.remove('on');
    cur.setAttribute('aria-hidden', 'true');
    nxt.classList.remove('out');
    nxt.classList.add('on');
    nxt.removeAttribute('aria-hidden');
    setTimeout(() => cur.classList.remove('out'), 650);
  };
  const start = () => { if (!timer) timer = setInterval(step, 3800); };
  const stop = () => { clearInterval(timer); timer = null; };
  box.addEventListener('mouseenter', stop);
  box.addEventListener('mouseleave', start);
  document.addEventListener('visibilitychange', () => (document.hidden ? stop() : start()));
  start();
}

// Header hides on scroll down and returns on scroll up; "stuck" adds a hairline.
function initHeader() {
  const hdr = document.getElementById('hdr');
  if (!hdr) return;
  let lastY = scrollY;
  let ticking = false;
  const update = () => {
    const y = scrollY;
    const menuOpen = document.documentElement.classList.contains('cd-open') || document.documentElement.classList.contains('bh-open') || document.getElementById('mnav')?.open;
    hdr.classList.toggle('is-stuck', y > 8);
    const hide = !menuOpen && !hdr.contains(document.activeElement) && y > lastY && y > 200;
    hdr.classList.toggle('hide', hide);
    document.documentElement.classList.toggle('hdr-hid', hide);
    lastY = y;
    ticking = false;
  };
  addEventListener('scroll', () => {
    if (!ticking) { ticking = true; requestAnimationFrame(update); }
  }, { passive: true });
}

// Mobile menu: native <dialog> gives focus trapping, Esc and scroll lock.
function initMobileMenu() {
  const dlg = document.getElementById('mnav');
  if (!dlg || typeof dlg.showModal !== 'function') return;
  document.addEventListener('click', (e) => {
    if (e.target.closest('[data-open-menu]')) dlg.showModal();
    else if (e.target.closest('[data-close-menu]') || e.target === dlg) dlg.close();
  });
  matchMedia('(min-width: 861px)').addEventListener('change', (mq) => { if (mq.matches && dlg.open) dlg.close(); });
}

// Back to top button appears after two screens of scrolling.
function initToTop() {
  const btn = document.querySelector('[data-to-top]');
  if (!btn) return;
  btn.hidden = false;
  const sentinelY = () => innerHeight * 2;
  addEventListener('scroll', () => btn.classList.toggle('on', scrollY > sentinelY()), { passive: true });
  btn.addEventListener('click', () => scrollTo({ top: 0, behavior: reduce ? 'auto' : 'smooth' }));
}

initAnnouncement();
initHeader();
initMobileMenu();
initToTop();
